import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Typography, Grid } from "@mui/material";
import styled from "styled-components";
import { Card as BootstrapCard } from "reactstrap";
import PincodeConfig from "../Picklist/PincodeConfig";
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
import WorkTypePicklist from "../Picklist/workType";
import PartyTypePicklist from "../Picklist/partyType";
import BoardMaster from "../Picklist/boardMaster";
import ClassMaster from "../Picklist/classMaster";
import CollectionType from "../Picklist/collectionType";
import ContactPersonRole from "../Picklist/contactPersonRole";
import DaType from "../Picklist/daType";
import FeedbackMaster from "../Picklist/feedbackMaster";
import GivenType from "../Picklist/givenType";
import GradeMaster from "../Picklist/gradeMaster";
import MediumMaster from "../Picklist/mediumMaster";
import NextType from "../Picklist/nextStep";
import PaymentType from "../Picklist/paymentType";
import RecieveCollection from "../Picklist/recieveCollection";
import RouteVisitType from "../Picklist/routeVisitType";
import StatusType from "../Picklist/statusType";
import SubjectMaster from "../Picklist/subjectMaster";
import VehicleType from "../Picklist/vehicleType";
import VisitType from "../Picklist/visitType";
import WorkDone from "../Picklist/workDone";
import ExpensePurpose from './../Picklist/expensePurpose';
import DocumentListSchool from "../Picklist/documentListSchool";
import ExpenseType from "../Picklist/expenseType";
import DeliveryStatus from "../Picklist/deliveryStatus";
import LeadStatus from "../Picklist/leadStatus";
import LeadSource from "../Picklist/leadSource";
import LeadRating from "../Picklist/leadRating";
import SchoolCategory from "../Picklist/schoolCategory";
import VisitOutcome from "../Picklist/visitOutcome";
import ReturnReason from "../Picklist/returnReason";
import ProductGroup from "../Picklist/productGroup";
import MittplusProductGroup from "../Picklist/mittplusProductGroup";
import SeriesMaster from "../Picklist/seriesMaster";
import VisitTypeCheck from "../Picklist/VisitTypeCheck";
import AddOnProducts from '../Picklist/AddOnProducts'
import RemarkComponent from "../Picklist/RemarkComponent";
import WareHouseComponent from "../Picklist/WareHouseComponent";
import ClusterComponent from "../Picklist/ClusterComponent";
import NotificationEmail from "../Picklist/NotificationEmail";
import CustomerType from "../Picklist/CustomerType";
import InputSource from "../Picklist/InputSource";
import SchoolType from "../Picklist/SchoolType";
import Reason from "../Picklist/Reason";
import AttendanceConfig from "../Picklist/AttendanceConfig";
import Cities from "../Picklist/Cities";
import ExpenseSubType from "../Picklist/ExpenseSubType";
import SessionManagement from "../Picklist/SessionManagement";
const HoverCard = styled(BootstrapCard)`
  cursor: pointer;
  transition: transform 0.3s ease,;
   box-shadow: 0px 4px 12px rgba(21, 20, 20, 0.33);
  width: 100%;
  max-width: 300px;
  
  &:hover {
    transform: scale(1.05);
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
     background-color: rgba(142, 170, 235, 0.57);
     color:white
  }
`;

const StaffEditorPageContainer = styled.div`
  height: ${window.innerWidth < 900 ? `auto` : `calc(100vh - 105px)`};
  width: 100%;
  background-color: white;
  padding: 10px 15px;
  margin-top: 20px;
  ${window.innerWidth < 900 && `position: relative`}
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${window.innerWidth < 900 ? "flex-start" : "space-between"};
  margin-bottom: 10px;
  flex-direction: ${window.innerWidth < 900 ? "column" : "row"};
`;

const FilterBar = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;

const FilterButton = styled.button`
  padding: 6px 12px;
  border-radius: 4px;
  border: 1px solid #ccc;
  background-color: ${(props) => (props.active ? "#007bff" : "#f9f9f9")};
  color: ${(props) => (props.active ? "white" : "black")};
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
`;

const PicklistContainer = styled.div`
  padding: 10px;
`;

export default function AllPicklist() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [accessChanges, setAccessChanges] = useState("");
  const [selectedSection, setSelectedSection] = useState("all");
  const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)

  const sectionLabels = {
    all: "All",
    party: "Party",
    route: "Route",
    product: "Product",
    collection: "Collection",
    order: "Order",
    visit: "Visit",
    expense: "Expense",
    global: "Global"
  };

  const routes = [
    {
      path: "/product/cluster",
      name: "Areas",
      component: ClusterComponent,
      access: "Picklist",
      showIn: "global"
    },
    {
      path: "/additionalData/routeVisitType",
      name: "Route Visit Type",
      component: RouteVisitType,
      access: "Picklist",
      showIn: "route"
    },
    {
      path: "/additionalData/boardMaster",
      name: "School Board",
      component: BoardMaster,
      access: "Picklist",
      showIn: "party"
    },
    {
      path: "/additionalData/classMaster",
      name: "Class",
      component: ClassMaster,
      access: "Picklist",
      showIn: "party"
    },
    {
      path: "/additionalData/collectionType",
      name: "Collection Type",
      component: CollectionType,
      access: "Picklist",
      showIn: "collection"
    },
    {
    path: "/additionalData/contactPersonRoleType",
    name: "Contact Person Role Type",
    component: ContactPersonRole,
    access: "Picklist",
    showIn: "party"
    },
    // {
    //   path: "/additionalData/datType",
    //   name: "DA Type",
    //   component: DaType,
    //   access: "Picklist",
    // },
    {
      path: "/additionalData/deliveryStatus",
      name: "Delivery Status",
      component: DeliveryStatus,
      access: "Picklist",
      showIn: "order"
    },
    // {
    //   path: "/additionalData/documentListSchool",
    //   name: "Document List School",
    //   component: DocumentListSchool,
    //   access: "Picklist",
    // },
    {
      path: "/additionalData/expensePurpose",
      name: "Expense Purpose",
      component: ExpensePurpose,
      access: "Picklist",
      showin: "expense"
    },
    {
      path: "/additionalData/expenseType",
      name: "Expense Type",
      component: ExpenseSubType,
      access: "Picklist",
      showin: "expense"
    },
    {
      path: "/additionalData/expenseSubType",
      name: "Expense Sub Type",
      component: ExpenseType,
      access: "Picklist",
      showin: "expense"
    },
    {
      path: "/additionalData/feedbackMaster",
      name: "Feedback",
      component: FeedbackMaster,
      access: "Picklist",
      showIn: "visit"
    },
    {
      path: "/additionalData/gradeMaster",
      name: "Grade",
      component: GradeMaster,
      access: "Picklist",
      showIn: "party"
    },
    {
      path: "/additionalData/givenType",
      name: "Given Type",
      component: GivenType,
      access: "Picklist",
      showIn: "global"
    },
    // {
    //   path: "/additionalData/leadRating",
    //   name: "Lead Rating",
    //   component: LeadRating,
    //   access: "Picklist",
    // },
    // {
    //   path: "/additionalData/leadSource",
    //   name: "Lead Source",
    //   component: LeadSource,
    //   access: "Picklist",
    // },
    // {
    //   path: "/additionalData/leadStatus",
    //   name: "Lead Status",
    //   component: LeadStatus,
    //   access: "Picklist",
    // },
    {
      path: "/additionalData/mittplusProductGroups",
      name: "Mittplus Product Groups",
      component: MittplusProductGroup,
      access: "Picklist",
      showIn: "product"
    },
    {
      path: "/additionalData/mediumMaster",
      name: "Medium",
      component: MediumMaster,
      access: "Picklist",
      showIn: "party"
    },
    {
      path: "/additionalData/nextStep",
      name: "Next Step",
      component: NextType,
      access: "Picklist",
      showIn: "visit"
    },
    {
      path: "/additionalData/paymentType",
      name: "Payment Type",
      component: PaymentType,
      access: "Picklist",
      showIn: "global"
    },
    {
      path: "/additionalData/productGroups",
      name: "Product Groups",
      component: ProductGroup,
      access: "Picklist",
      showIn: "product"
    },
    {
      path: "/additionalData/partyType",
      name: "Party Type",
      component: PartyTypePicklist,
      access: "Picklist",
      showIn: "party"
    },
    {
      path: "/additionalData/recieveCollectionType",
      name: "Recieve Collection Type",
      component: RecieveCollection,
      access: "Picklist",
      showIn: "collection"
    },
    {
      path: "/additionalData/returnReason",
      name: "Return Reason",
      component: ReturnReason,
      access: "Picklist",
      showIn: "global"
    },

    {
      path: "/additionalData/schoolCategory",
      name: "School Category",
      component: SchoolCategory,
      access: "Picklist",
      showIn: "party"
    },
    {
      path: "/additionalData/statusType",
      name: "Status Type",
      component: StatusType,
      access: "Picklist",
      showIn: "visit"
    },
    {
      path: "/additionalData/subjectMaster",
      name: "Subject",
      component: SubjectMaster,
      access: "Picklist",
      showIn: "party"
    },
    {
      path: "/additionalData/vehicleType",
      name: "Vehicle Type",
      component: VehicleType,
      access: "Picklist",
      showIn: "visit"
    },
    {
      path: "/additionalData/visitOutcomes",
      name: "Visit Outcomes",
      component: VisitOutcome,
      access: "Picklist",
      showIn: "visit"
    },
    // {
    //   path: "/additionalData/visitType",
    //   name: "Visit Type",
    //   component: VisitType,   // ye krna haii 
    //   access: "Picklist",
    // },
    // {
    //   path: "/additionalData/visitTypeCheck",
    //   name: "Visit Time",
    //   component: VisitTypeCheck,  //  backend me api path nahi ha
    //   access: "Picklist",
    // },
    {
      path: "/additionalData/workDone",
      name: "Work Done",
      component: WorkDone,
      access: "Picklist",
      showIn: "visit"
    },
    // {
    //   path: "/additionalData/workTypePicklist",
    //   name: "Work Type",
    //   component: WorkTypePicklist,
    //   access: "Picklist",
    // },
    {
      path: "/product/seriesCategory",
      name: "Series",
      component: SeriesMaster,
      access: "Picklist",
      showIn: "global"
    },
    {
      path: "/product/addOnProducts",
      name: "AddOnProducts",
      component: AddOnProducts,
      access: "Picklist",
      showIn: "product"
    },
    {
      path: "/product/remark",
      name: "Order Remark",
      component: RemarkComponent,
      access: "Picklist",
      showIn: "order"
    },
    {
      path: "/product/wareHouse",
      name: "WareHouse",
      component: WareHouseComponent,
      access: "Picklist",
      showIn: "order"
    },
    {
      path: "/product/notificationEmail",
      name: "Notification Email",
      component: NotificationEmail,
      access: "Picklist",
      showIn: "global"
    },
    // Session Management should only be available to super admin users
    ...(String(userData && userData.role) === "super admin"
      ? [{
          path: "/session/sessionManagement",
          name: "Session Management",
          component: SessionManagement,
          access: "Picklist",
          showIn: "global"
        }]
      : []),
    {
      path: "/additionalData/customerType",
      name: "Customer Type",
      component: CustomerType,
      access: "Picklist",
      showIn: "party"
    },
    {
      path: "/additionalData/inputSource",
      name: "Lead Source",
      component: InputSource,
      access: "Picklist",
      showIn: "party"
    },
    {
      path: "/additionalData/reason",
      name: "No Interest Reason",
      component: Reason,
      access: "Picklist",
      showIn: "visit"
    },

    {
      path: "/additionalData/cities",
      name: "Cities",
      component: Cities,
      access: "Picklist",
      showIn: "global"
    },
    {
      path: "/additionalData/attendanceConfig",
      name: "Attendance Configuration",
      component: AttendanceConfig,
      access: "Picklist",
      showIn: "global"
    },
     {
      path: "/additionalData/pincode",
      name: "Pincode",
      component: PincodeConfig,
      access: "Picklist",
      showIn: "global"
    },
    {
      path: "/additionalData/schoolType",
      name: "School Type",
      component: SchoolType,
      access: "Picklist",
      showIn: "party"
    },
  ];

  const filteredRoutes =
    selectedSection === "all"
      ? routes
      : routes.filter((route) => route.showIn === selectedSection);

  return (
    <StaffEditorPageContainer>
      {loading && <OpaqueLoading />}
      {["global", "route", "party", "collection", "order", "expense", "visit", "product"].map((sectionKey, index, arr) => {
        const sectionRoutes = routes.filter(
          (route) =>
            (route.showIn || route.showin)?.toLowerCase() === sectionKey.toLowerCase()
        );

        if (sectionRoutes.length === 0) return null;

        return (
          <div key={sectionKey} >
            <div>
              <hr style={{ margin: "0px", width: "100%", color: "black", borderColor: "#333" }} />
            <Typography sx={{
              textAlign: "left",
              width: "100%",
              // backgroundColor: "#669bebff",
              marginBottom: 1,
              marginLeft: "10px",
              color: "black",
            }} variant="h6" >
              {sectionKey.toUpperCase()}
            </Typography>
            <hr style={{ margin: "0px", width: "100%", color: "black", borderColor: "#333", borderWidth: "1.5px" }} />
            </div>
            <Grid container spacing={1} className="mt-2">
              {sectionRoutes.map((route) => (
                <Grid item xs={12} sm={4} md={3} key={route.name}>
                  <HoverCard onClick={() => navigate(route.path)}>
                    <PicklistContainer>
                      <Typography
                        sx={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "500",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {route.name}
                      </Typography>
                    </PicklistContainer>
                  </HoverCard>
                </Grid>
              ))}
            </Grid>
          </div>
        );
      })}
    </StaffEditorPageContainer>
  );
}
